import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _EditLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M15 5.914c.36 0 .653.152.916.353.251.191.528.47.852.794l.171.171c.324.324.603.6.794.852.201.263.353.556.353.916s-.152.653-.353.916c-.191.251-.47.528-.794.852l-7.194 7.194c-.176.176-.326.332-.517.44s-.403.157-.644.217l-2.654.664c-.164.041-.343.087-.492.102-.154.015-.415.01-.625-.199-.209-.209-.213-.47-.198-.625.015-.148.06-.326.102-.49l.664-2.655c.06-.241.109-.453.217-.643.108-.191.264-.342.44-.518l7.194-7.194c.324-.324.6-.603.852-.794.263-.201.556-.353.916-.353Z" }),
            React.createElement("path", { fill: "currentColor", d: "m12.5 7.5 3-2 3 3-2 3z" })));
}
const EditLight = forwardRef(_EditLight);
export { EditLight };
